import { render, staticRenderFns } from "./BindUpload.vue?vue&type=template&id=313d6b61&"
import script from "./BindUpload.vue?vue&type=script&lang=js&"
export * from "./BindUpload.vue?vue&type=script&lang=js&"
import style0 from "./BindUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports